import { useContext } from "react";
import { IFlow } from "../services/createFlow";

export const useFlow = <T, S extends object>(flow: IFlow<T, S>) => {
  return useContext(flow.context);
};
